import { ValueOf } from '@/types/util';

export const EPaymentMethod = {
  PREPAID: 'プリペイド',
  DIRECT_BANK: '銀行口座ダイレクト',
  CREDIT_CARD: 'クレジットカード',
} as const;

export type PaymentMethodKey = keyof typeof EPaymentMethod;
export type PaymentMethodValue = ValueOf<typeof EPaymentMethod>;

export const paymentMethodKeys = Object.keys(EPaymentMethod) as PaymentMethodKey[];

/** v-select用items */
export const paymentMethodItems = paymentMethodKeys
  .map((key) => ({
    title: EPaymentMethod[key],
    value: key,
  }));
